import BaseMenu from './BaseMenu';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import { applyDefaultButtonAnimation } from '../UIHelper';
import Renderable from '../../../Component/Renderable';
import Game from '../../../Game';
import {
    PlayAnimation,
    GetAnimationClip,
} from '../../Animation/AnimationHelper';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import {
    APP_LINK,
    EMAIL_SUBJECT,
    SUPPORT_EMAIL,
} from '../../../Constants/RateOurApp';

const BTN_SUBMIT = 'main_container/button_submit';
const BTN_LATER = 'main_container/button_later';

export default class RateAppHandler extends BaseMenu {
    private stars: Renderable[];
    private selectedStars: number;

    constructor(uiSystem: BaseUISystem) {
        super('rateAppMenu', uiSystem);

        this.clipShow = 'RateAppShow';
        this.clipHide = 'Alpha';
    }

    protected onCreate(): void {
        const stars = this.element.find('main_container/group_stars');
        this.stars = [];

        stars.children.forEach((star, index) => {
            star.on(GameObjectEvent.POINTER_OVER, () => {
                this.updateStars(index);
            });
            star.on(GameObjectEvent.SELECTED, () => {
                this.selectedStars = index;
                this.updateStars(this.selectedStars);
            });
            this.stars.push(star.children[1].getComponent(Renderable));
        });

        this.selectedStars = this.stars.length;
        this.updateStars(this.selectedStars);

        stars.on(GameObjectEvent.POINTER_OUT, () => {
            this.updateStars(this.selectedStars);
        });

        const btnSubmit = this.element.find(BTN_SUBMIT);
        btnSubmit.on(GameObjectEvent.SELECTED, () => {
            const value = this.stars.filter(star => star.visible).length;
            if (value > 3) {
                Game.sdk.driver.openMarket(APP_LINK);
                Game.state.dispatch(PlayerActions.submitRate());
            } else {
                Game.sdk.driver.sendEmail(SUPPORT_EMAIL, EMAIL_SUBJECT);
            }
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnSubmit, AUDIO_UI_BUTTON_DEFAULT);

        const btnLater = this.element.find(BTN_LATER);
        btnLater.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnLater, AUDIO_UI_BUTTON_CLOSE);
    }

    protected playHideAnimation() {
        return PlayAnimation(
            GetAnimationClip(this.clipHide, this.element, {
                duration: 500,
                startAlpha: 1,
                endAlpha: 0,
            })
        );
    }

    private updateStars(index: number): void {
        this.stars.forEach((star, ix) => {
            star.visible = ix <= index;
        });
    }
}
